import { authClient } from "@superadmin/utils/auth.client";
import { orpcFetch } from "@superadmin/utils/orpc.client";
import { redirect } from "react-router";

export interface AdminIdentity {
	name: string;
	email: string;
	image: string | null;
}

/**
 * The layout gate: signed in, AND on the super-admin allowlist.
 *
 * The second half is answered by the server (`superAdmin.ping`), never by the
 * client — the allowlist lives in the backend's env and a client-side copy
 * would be a second one to keep in step. A 403 is a person with a perfectly
 * good Google account who is not an operator, and gets words saying so
 * instead of nine panels failing separately.
 */
export async function adminLoader(): Promise<{ identity: AdminIdentity }> {
	const { data: session } = await authClient.getSession();

	if (!session) throw redirect("/auth/login");

	try {
		await orpcFetch.superAdmin.ping();
	} catch (error) {
		if ((error as { status?: number }).status === 403) {
			throw redirect("/auth/denied");
		}

		throw error;
	}

	return {
		identity: {
			name: session.user.name,
			email: session.user.email,
			image: session.user.image ?? null,
		},
	};
}
